import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchApi } from "../utils/api";
import '../style/Dashboard.css';
import AdminDashboard from '../components/Admin/AdminDashboard';
import SelectCampaign from "../pages/user/SelectCampaign";
import successIcon from "../assets/icon/succes.png";
import failedIcon from "../assets/icon/failed.png";
import NotificationInfo from "../pages/admin/NotificationInfo"; // Import komponen yang sama

// Komponen DashboardCredit (tetap sama)
const DashboardCredit = () => {
  const [credit, setCredit] = useState(0);
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('user')) || {};

  useEffect(() => {
    const fetchCredit = async () => {
      try {
        const res = await fetchApi(`/auth/users/${user.id}`);
        if (res) {
          setCredit(res.total_credit || 0);
          setBalance(res.balance || 0);
        }
      } catch (err) {
        console.error("Failed to fetch credit:", err.message);
      } finally {
        setLoading(false);
      }
    };

    if (user.id) {
      fetchCredit();
    } else {
      setLoading(false);
    }
  }, [user.id]);

   return (
    <div className="dashboard-card">
      <div className="card-header-dashboard">
        <h2>Credit</h2>
      </div>
      
      <div className="balance-credit-container">
        <div className="credit-section">
          <p className="credit-value">
            {loading ? "Loading..." : credit}
          </p>
          <p className="credit-info">
            {credit > 0
              ? `Your current credits is ${credit}`
              : "You don't have any credits."}
          </p>
        </div>
        <button className="btn-primary-credit" onClick={() => navigate("/deposits/topup")}>
        + Top Up Credit
      </button>
      </div>
    </div>
  );
};

// Komponen What's New / Notifications - UPDATED with click handler
const WhatsNew = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedNotification, setSelectedNotification] = useState(null); // State untuk modal

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return (
      date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }) + " WIB"
    );
  };

  // Fungsi untuk menutup modal
  const handleCloseModal = () => {
    setSelectedNotification(null);
  };

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const res = await fetchApi("/notifications");
        if (Array.isArray(res)) {
          setNotifications(res);
        } else if (res.success && Array.isArray(res.data)) {
          setNotifications(res.data);
        }
      } catch (err) {
        console.error("Failed to fetch notifications:", err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchNotifications();
  }, []);

  return (
    <>
      <div className="news-section">
        <h2 className="news-heading">What's New</h2>

        <div className="news-container">
          {loading ? (
            <p className="news-loading">Loading news...</p>
          ) : notifications.length === 0 ? (
            <p className="news-empty">No updates available.</p>
          ) : (
            <div className="news-scroll-container">
              {notifications
                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                .map((n) => (
                  <div 
                    key={n.id} 
                    className="news-item clickable" // Tambah class clickable
                    onClick={() => setSelectedNotification(n)} // Tambah onClick handler
                    role="button" // Untuk aksesibilitas
                    tabIndex={0} // Untuk bisa di-focus keyboard
                    onKeyPress={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        setSelectedNotification(n);
                      }
                    }} // Untuk akses keyboard
                  >
                    <p className="news-date">{formatDate(n.created_at)}</p>
                    <h3 className="news-title">{n.title}</h3>
                    <div
                      className="news-content"
                      dangerouslySetInnerHTML={{ 
                        __html: n.content.length > 150 
                          ? n.content.substring(0, 150) + '...' 
                          : n.content 
                      }} // Preview konten
                    />
                    <hr className="news-divider" />
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>

      {/* ✅ Modal Detail Info */}
      {selectedNotification && (
        <div className="modal-overlay-user" onClick={handleCloseModal}>
          <div className="modal-content-notif-user" onClick={(e) => e.stopPropagation()}>
            <NotificationInfo
              notification={selectedNotification}
              onClose={handleCloseModal}
            />
          </div>
        </div>
      )}
    </>
  );
};

// Komponen UserDashboard (tetap sama)
const UserDashboard = () => {
  const [successCount, setSuccessCount] = useState(0);
  const [failedCount, setFailedCount] = useState(0);
  const [onProcessCount, setOnProcessCount] = useState(0);
  const [loadingCampaign, setLoadingCampaign] = useState(true);
  const navigate = useNavigate();
   const [showSelectModal, setShowSelectModal] = useState(false);
  const [selectedChannel, setSelectedChannel] = useState(null);

  useEffect(() => {
    const fetchCampaignStats = async () => {
      try {
        const res = await fetchApi("/campaigns");
        if (res.success) {
          const campaigns = res.data || [];
          const success = campaigns.filter(c => c.status === "success").length;
          const failed = campaigns.filter(c => c.status === "failed").length;
          const onProcess = campaigns.filter(c => c.status === "on_process").length;

          setSuccessCount(success);
          setFailedCount(failed);
          setOnProcessCount(onProcess);
        }
      } catch (err) {
        console.error("Failed to fetch campaigns:", err.message);
      } finally {
        setLoadingCampaign(false);
      }
    };

    fetchCampaignStats();
  }, []);

  return (
    <div>
      {/* Credit & Campaign Stats */}
      <div className="dashboard-grid">
        <DashboardCredit />

        <div className="dashboard-card">
          <div className="card-header-dashboard">
            <h2>Campaign</h2>
          </div>
          <div className="campaign-stats">
            <div className="stat success">
              <span className="stat-number">
                                <img
                  src={successIcon}
                  alt="Success"
                  className="success-icon-img"
                />
                {loadingCampaign ? "..." : successCount}
              </span>
              <span>Success</span>
            </div>
            <div className="stat failed">
              <span className="stat-number">
                <img
                  src={failedIcon}
                  alt="Failed"
                  className="failed-icon-img"
                />
                {loadingCampaign ? "..." : failedCount}
              </span>
              <span>Failed</span>
            </div>
            <div className="stat on-process">
              <span className="stat-number">
                {loadingCampaign ? "..." : onProcessCount}
              </span>
              <span>On Process</span>
            </div>
          </div>
      <button 
      className="btn-link" 
      onClick={() => navigate("/campaign")}>
      View Campaign →
    </button>
        </div>
      </div>

      {/* What's New Section */}
      <WhatsNew />
       <button className="btn-primary" onClick={() => setShowSelectModal(true)}>+ Create Campaign</button>

       {showSelectModal && (
         <div
           className="sc-overlay"
           onClick={(e) => {
             if (e.target === e.currentTarget) {
               setShowSelectModal(false);
             }
           }}
         >
           <div className="sc-modal">
             <SelectCampaign
               onBack={() => setShowSelectModal(false)}
               onNext={() => {
                 if (selectedChannel === "whatsapp") {
                   navigate("/campaigns/createwa");
                 } else if (selectedChannel === "sms") {
                   navigate("/campaigns/createsms");
                 }
                 setShowSelectModal(false);
               }}
               onSelectChannel={(ch) => setSelectedChannel(ch)}
               selected={selectedChannel}
             />
           </div>
         </div>
       )}
    </div>
  );
};

// Komponen utama Dashboard
const Dashboard = () => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const role = user.role || 'user';

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-titles">Dashboard</h1>
      <p className="welcome-text">Welcome, {user.name || 'User'}!</p>

      {role === 'admin' ? <AdminDashboard /> : <UserDashboard />}
    </div>
  );
};

export default Dashboard;